export var ConversationType;
(function (ConversationType) {
    ConversationType["TravelerToZicasso"] = "TRAVELER_TO_ZICASSO";
    ConversationType["TravelerToPartner"] = "TRAVELER_TO_PARTNER";
    ConversationType["ZicassoToPartner"] = "ZICASSO_TO_PARTNER";
})(ConversationType || (ConversationType = {}));
